export default __webpack_public_path__ + "static/media/bg4.a937e1a8.jpg";